/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'angular2-spinner/dist/angular2-spinner';
const styles_SpinnerComponent:any[] = ['@keyframes spin {\n      from {transform: rotate(0deg);}\n      to {transform: rotate(360deg);}\n    }\n\n    [_nghost-%COMP%] {\n      position:relative;\n      box-sizing: border-box;\n      display:inline-block;\n      padding:0px;\n      border-radius:100%;\n      border-style:solid;\n      animation: spin 0.8s linear infinite;\n    }\n\n    [_nghost-%COMP%]   .margins[_ngcontent-%COMP%] {\n        margin: 0px 10px;\n    }'];
export const RenderType_SpinnerComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 0,
  styles: styles_SpinnerComponent,
  data: {}
}
);
export function View_SpinnerComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
function View_SpinnerComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),View_SpinnerComponent_0,RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import1.SpinnerComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).size;
    const currVal_1:any = import0.ɵnov(v,1).size;
    const currVal_2:any = import0.ɵnov(v,1).tickness;
    const currVal_3:any = import0.ɵnov(v,1).color;
    const currVal_4:any = import0.ɵnov(v,1).secondColor;
    const currVal_5:any = import0.ɵnov(v,1).secondColor;
    const currVal_6:any = import0.ɵnov(v,1).secondColor;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
export const SpinnerComponentNgFactory:import0.ComponentFactory<import1.SpinnerComponent> = import0.ɵccf('spinner',import1.SpinnerComponent,View_SpinnerComponent_Host_0,{
  size: 'size',
  tickness: 'tickness',
  color: 'color',
  opacity: 'opacity'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLXNwaW5uZXIvZGlzdC9hbmd1bGFyMi1zcGlubmVyLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLXNwaW5uZXIvZGlzdC9hbmd1bGFyMi1zcGlubmVyLmQudHMiLCJuZzovLy9zdG9yYWdlL3Zob3N0L3BhbmVsLmRhdGFzcGFjZS5wbC93ZWIvZGF0YXNwYWNlLWNwLWRzLWZyb250L25vZGVfbW9kdWxlcy9hbmd1bGFyMi1zcGlubmVyL2Rpc3QvYW5ndWxhcjItc3Bpbm5lci5kLnRzLlNwaW5uZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c3Bpbm5lcj48L3NwaW5uZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBOzs7SUFBQTs7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFNBQUEscUVBQUE7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/~/angular2-spinner/dist/angular2-spinner.ngfactory.ts